import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PayloadService {
  nationwideChoosePaymentMethodPayload: nationwideChoosePaymentMethodPayload = {
    details: {
      clientID: '',
      customerAccessToken: '',
      lineOfBusiness: '',
      paymentMethod: '',
      hideCVV: false,
      plaid: false,
      consumerId: 'mwcconnect',
      savedPaymentMethod: false,
    },
    messageId: '',
    inline: "",
    nationwideEnvironment: environment.env
    // use local for local testing but make sure to revert to dev before pull into develop or master
  };
}

export interface nationwideChoosePaymentMethodPayload {
  messageId: string;
  details: { [key: string]: any };
  inline?: string;
  nationwideEnvironment: string;
}
